import type { Action } from 'state/actions';

import type { AddonManagementWorkspaceState } from './addonManagement.model';
import { initialAddonManagementWorkspaceState } from './addonManagement.model';

export function addonManagementWorkspacesReducer(
  state: AddonManagementWorkspaceState = initialAddonManagementWorkspaceState,
  action: Action,
): AddonManagementWorkspaceState {
  switch (action.type) {
    case 'ADDON_MANAGEMENT_FORMS_REQUESTED':
      return {
        ...state,
        isLoading: true,
      };
    case 'ADDON_MANAGEMENT_FILTER_CHANGED':
      return {
        filters: action.filters,
        isLoading: true,
      };
    case 'ADDON_MANAGEMENT_FILTERS_LOADED':
      return {
        ...state,
        filters: action.filters,
      };
    case 'ADDON_MANAGEMENT_FORMS_RECEIVED':
      return {
        ...state,
        isLoading: false,
        isTradesFetchSuccessful: action.isTradesFetchSuccessful,
      };
    case 'ADDON_MANAGEMENT_FORMS_FAILED':
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case 'ADDON_MANAGEMENT_FORM_HEADER_CHECKBOX_TOGGLE':
      return state;
    default:
      return state;
  }
}
